@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.grid-columns {
  display: grid;
  height: 100%;
  width: 100%;
  color: @containers--grid-columns--text-color;
  grid-template-columns:
    minmax(250px, 1fr)
    minmax(500px, 1.5fr);
  align-items: center;

  @media screen and (max-width: 1100px) {
    grid-template-columns:
      minmax(250px, 3fr)
      minmax(500px, 1.5fr);
  }
  &:hover {
    color: @containers--grid-columns--hover--text-color;
    text-decoration: none;
  }
}
